export function arrayWithoutEmptyOrNull(array, isItemSet = null) {
    if (array === null || !Array.isArray(array) || array.length === 0) return null;

    if (isItemSet) array = array.filter((i) => isItemSet(i));
    if (array.length === 0) return null;

    return array;
}
